import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buttonVersion)?_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.copyContent}},[_c(VIcon,{attrs:{"size":16}},[_vm._v("mdi-content-copy")])],1):_c(VIcon,{staticClass:"copyBtn",attrs:{"size":16},on:{"click":_vm.copyContent}},[_vm._v("mdi-content-copy")])}
var staticRenderFns = []

export { render, staticRenderFns }